/* Resupply, layout D: tabs choose the module. Desktop stacks the modules and shows one; phones lay them in a row that
   snaps, so a tab scrolls to its module and scrolling updates the tabs. */
(function () {
  var s = document.querySelector('[data-resupply][data-variant="d"]'); if (!s) return;
  var tabs = Array.prototype.slice.call(s.querySelectorAll('[data-rs-tab]'));
  var mods = Array.prototype.slice.call(s.querySelectorAll('[data-rs-mod]'));
  var row = s.querySelector('[data-rs-mods]');
  var phone = function () { return matchMedia('(max-width: 860px)').matches; };
  /* drive the row ourselves: smooth scrollTo is ignored while scroll-snap is mandatory (the pack gallery hit the same), so snap
     comes off for the glide and back on at the end */
  var driving = null;
  function glide(el, to) {
    if (driving) cancelAnimationFrame(driving);
    var from = el.scrollLeft, d = to - from, t0 = performance.now(), dur = Math.min(520, 220 + Math.abs(d) * .35);
    el.style.scrollSnapType = 'none';
    var step = function (now) {
      var p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.scrollLeft = from + d * e;
      if (p < 1) driving = requestAnimationFrame(step); else { driving = null; el.scrollLeft = to; el.style.scrollSnapType = ''; }
    };
    driving = requestAnimationFrame(step);
    /* rAF is throttled in a hidden tab: land it by timer as well, so snap always comes back */
    setTimeout(function () { if (driving) { cancelAnimationFrame(driving); driving = null; el.scrollLeft = to; el.style.scrollSnapType = ''; } }, dur + 120);
  }
  var thumb = s.querySelector('[data-rs-thumb]');
  function mark(i) {
    tabs.forEach(function (t, k) { t.classList.toggle('on', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    mods.forEach(function (m, k) { m.classList.toggle('on', k === i); });
    if (thumb && tabs[i]) {
      var t = tabs[i]; thumb.style.setProperty('--x', t.offsetLeft + 'px'); thumb.style.setProperty('--w', t.offsetWidth + 'px');
      var mix = (mods[i] && mods[i].style.getPropertyValue('--mix') || '58%').trim();
      thumb.style.setProperty('--c', t.style.getPropertyValue('--c')); thumb.style.setProperty('--mix', mix);
      tabs.forEach(function (x, k) { x.classList.toggle('light', k === i && mix === '100%'); }); /* a tab on a printed light colour (stone) reads dark */
      /* phones: keep the chosen tab in view inside the plate */
      var bar = t.parentElement; if (bar.scrollWidth > bar.clientWidth + 2) { var want = t.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2; bar.scrollTo({ left: Math.max(0, want), behavior: 'smooth' }); }
    }
  }
  addEventListener('resize', function () { var i = tabs.findIndex(function (t) { return t.classList.contains('on'); }); if (i >= 0) mark(i); });
  mark(Math.max(0, tabs.findIndex(function (t) { return t.classList.contains('on'); })));
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () {
      /* phones: move the row sideways only — scrollIntoView also nudged the page vertically, which jolted the sticky tabs */
      if (phone() && row) glide(row, mods[i].offsetLeft - row.offsetLeft);
      mark(i);
    });
  });
  /* the tabs pin under the header; when the header hides on scroll they pin to the top instead (as the compare picker does) */
  var header = document.querySelector('.rr-header'), bar = s.querySelector('.tabs');
  if (header && bar && 'MutationObserver' in window) {
    var up = function () { bar.classList.toggle('tabs-up', header.classList.contains('is-hidden')); };
    up(); new MutationObserver(up).observe(header, { attributes: true, attributeFilter: ['class'] });
  }
  if ('IntersectionObserver' in window && row) {
    var io = new IntersectionObserver(function (list) {
      if (!phone()) return;
      list.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > .6) mark(mods.indexOf(e.target)); });
    }, { root: row, threshold: [.6] });
    mods.forEach(function (m) { io.observe(m); });
  }
})();

/* Quantity in the buy row: − 1 + beside the button; the button's price follows the count. The form submits through
   product-form.js as before (quantity is a plain form field). */
(function () {
  document.querySelectorAll('[data-rs-qty]').forEach(function (q) {
    var n = q.querySelector('.n'), price = +q.dataset.price || 0, form = q.closest('form'), slot = form && form.querySelector('[data-core-cta-price]');
    var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); };
    function sync() { var v = Math.max(1, Math.min(20, parseInt(n.value, 10) || 1)); n.value = v; if (slot) slot.textContent = money(price * v); q.querySelector('[data-rs-step="-1"]').disabled = v <= 1; }
    q.addEventListener('click', function (e) { var b = e.target.closest('[data-rs-step]'); if (!b) return; n.value = (parseInt(n.value, 10) || 1) + (+b.dataset.rsStep); sync(); });
    n.addEventListener('input', sync); sync();
    /* after an add, product-form.js re-enables the button; the count goes back to one */
    if (form) form.addEventListener('submit', function () { setTimeout(function () { n.value = 1; sync(); }, 1500); });
  });
})();

/* Tiles (module pages and the Resupply stage): play swaps the cut-out for the unboxing film (sound on, since the person
   asked for it; a second tap pauses and brings the cut-out back). */
(function () {
  document.querySelectorAll('[data-rs-tile]').forEach(function (t) {
    var film = t.querySelector('[data-rs-tile-film]'), play = t.querySelector('[data-rs-tile-play]'), sound = t.querySelector('[data-rs-tile-sound]'), v = film && film.querySelector('video');
    if (!play || !film) return;
    play.addEventListener('click', function () {
      var on = film.hidden;
      film.hidden = !on; t.classList.toggle('playing', on);
      play.setAttribute('aria-pressed', on ? 'true' : 'false'); play.setAttribute('aria-label', on ? 'Pause the film' : 'Play the unboxing film'); play.querySelector('.m').textContent = on ? 'Pause' : 'Play';
      if (sound) sound.hidden = !on || !v;
      if (v) { if (on) { v.muted = false; v.currentTime = 0; v.play().catch(function () { v.muted = true; v.play().catch(function () {}); }); } else { v.pause(); } }
    });
    if (sound && v) sound.addEventListener('click', function () { v.muted = !v.muted; sound.setAttribute('aria-pressed', v.muted ? 'false' : 'true'); sound.setAttribute('aria-label', v.muted ? 'Unmute film' : 'Mute film'); sound.querySelector('.m').textContent = v.muted ? 'Sound off' : 'Sound on'; });
  });
  /* the Resupply stage: switching tab pauses whatever was playing */
  document.querySelectorAll('[data-rs-tab]').forEach(function (b) { b.addEventListener('click', function () { document.querySelectorAll('[data-rs-tile].playing [data-rs-tile-play]').forEach(function (p) { p.click(); }); }); });
})();

/* Phones: the About and Inside folds start closed so the stage stays short; desktop keeps them open. */
(function () {
  if (!matchMedia('(max-width: 860px)').matches) return;
  document.querySelectorAll('[data-rs-fold]').forEach(function (d) { d.removeAttribute('open'); });
})();
